import axios from 'axios';
import { SET_FOOTER_MODAL, SAVE_ERROR_MESSAGE, FETCH_ERROR_MESSAGE, FETCH_ERROR_MESSAGE_FAIL  } from './types';
import { SLACK_WEBHOOKS } from '../config';


/**
 * Slack webhook
 */
export function SlackWebhook(slackWebhook, payload){

  const config = {
    headers:{
      'Content-type': 'application/x-www-form-urlencoded'
    }
  };


  return (dispatch) => {
    if (process.env.NODE_ENV === 'production'){
      axios.post(slackWebhook, JSON.stringify(payload), config).then(response => {
        //console.log(response)
      });
    }
  }
}


/**
 * Error message via Busabout API
 *
 */
 export function FetchErrors(){

  const errorURL = `${process.env.REACT_APP_ERROR_API}?api_token=${process.env.REACT_APP_API_TOKEN}`

   return async dispatch => {
    try{
      const response = await axios.get(errorURL, {withCredentials: true});
      dispatch({type:FETCH_ERROR_MESSAGE, payload:response.data});
     }
     catch(err){
       console.error(err);
       dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! ERROR API (GET) - ' + errorURL + " " + err}));
       dispatch({type:FETCH_ERROR_MESSAGE_FAIL})
     }
   }
 }



/**
 * Save single product payload from Busabout Matrix page
 */
 export function SaveError(data){
   return dispatch => dispatch({type:SAVE_ERROR_MESSAGE, payload:data})
 }


/**
 * Footer modal
 */
export function ToggleFooterModal(link, isOpen){
 return dispatch => dispatch({type:SET_FOOTER_MODAL, payload:{link, isOpen}})
}



// WEBPACK FOOTER //
// ./src/actions/utils.js